import { render, staticRenderFns } from "./DeadCintilloPataGrid.vue?vue&type=template&id=431ccee8&scoped=true"
import script from "./DeadCintilloPataGrid.vue?vue&type=script&lang=js"
export * from "./DeadCintilloPataGrid.vue?vue&type=script&lang=js"
import style0 from "./DeadCintilloPataGrid.vue?vue&type=style&index=0&id=431ccee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431ccee8",
  null
  
)

export default component.exports